import React, { Component } from "react";
import ReportHeader from "../../../Report/ReportHeader";
import axios from "axios";
import Spinner from "../../../Common/Spinner";
import * as appConst from "../../../Common/constants";
import moment from "moment";
import line from "../../../Images/line.jpeg";

var sectionStyle = {
  backgroundImage: `url(${line})`
};

class HomeCare extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      spinnerClass: "",
      dataClass: "collapse"
    };

  }

  componentDidMount() {
    this.LoadDetails();
  }

  LoadDetails() {
    var obj = {
      fromDate: this.props.data.fromDate,
      toDate: this.props.data.toDate,
      type: this.props.data.type
    }
    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/patient/homeCare/report",
        obj
      )
      .then(response => {
        this.setState({
          data: response.data,
          spinnerClass: "collapse",
          dataClass: ""
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  tabRow() {
    if (this.state.data != null) {
      return this.state.data.map(function (obj) {

        let displayDate = "";
        if (obj.date !== null && obj.date !== "") {
          var arrDate = new Date(obj.date).toDateString().split(" ");
          displayDate = arrDate[2] + "-" + arrDate[1] + "-" + arrDate[3];
        }
        return (
          <tr key={obj._id}>
            <td className="border p-1">{obj.pno}</td>
            <td className="border p-1 text-wrap">{obj.patient}</td>
            <td className="border p-1">{displayDate}</td>
            <td className="border p-1">{obj.type}</td>
          </tr>
        );
      });
    }
  }

  DisplayFilter() {
    var arrFrom = new Date(this.props.data.fromDate).toDateString().split(" ");
    var arrTo = new Date(this.props.data.toDate).toDateString().split(" ");
    return (
      arrFrom[2] + "-" + arrFrom[1] + "-" + arrFrom[3] +
      " to " +
      arrTo[2] + "-" + arrTo[1] + "-" + arrTo[3]
    );
  }

  render() {
    return (
      <div>
        <ReportHeader onCloseClick={this.onCloseClick} IsClose="1" />
        <h3 align="center">Home Care Report - {this.DisplayFilter()}</h3>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="container-fluid reportFont">
            <table>
              <thead>
                <tr>
                  <th className="border p-1 font-weight-bold" width="200px">Patient #</th>
                  <th className="border p-1 font-weight-bold" width="400px">
                    Patient Name
                  </th>
                  <th className="border p-1 font-weight-bold" width="150px">
                    Date
                  </th>
                  <th className="border p-1 font-weight-bold" width="150px">
                    Type
                  </th>
                </tr>
              </thead>
              <tbody>{this.tabRow()}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }



  onCloseClick = e => {
    this.props.onCloseClick("Filter", null);
  };
}

export default HomeCare;
